import React from 'react';
import { Link } from 'react-router-dom';
import
    { FormGroup
    , Breadcrumbs
} from '@germix/germix-react-core';
import { withTranslation, WithTranslation } from 'react-i18next';

import Application from '../components/app/Application';

interface Props extends WithTranslation
{
}
interface State
{
    textInput,
    encodedOutput,
}

/**
 * @author Germán Martínez
 */
class RouteToolsEncoderURL extends React.Component<Props,State>
{
    state: State =
    {
        textInput: '',
        encodedOutput: '',
    }
    render()
    {
        const { t } = this.props;

        return (
<Application>
    <FormGroup>
        <Breadcrumbs>
            <Link to='/'>{t('titles.home')}</Link>
            <Link to='/tools'>{t('titles.tools')}</Link>
            <Link to='/tools/url-encoder'>{t('titles.toolsEncoderURL')}</Link>
        </Breadcrumbs>
        <br/>
    </FormGroup>
    <FormGroup>
        <h1>{t('titles.toolsEncoderURL')}</h1>
    </FormGroup>
    <FormGroup>
        <div className="row">
            <div className="col">
                <FormGroup>
                    <label>{t('toolEncoderURL.inputLabel')}</label>
                    <textarea
                        className="form-control"
                        value={this.state.textInput}
                        style={{
                            resize: 'vertical',
                            minHeight: '200px',
                        }}
                        onChange={(e) =>
                        {
                            this.setState({
                                textInput: e.target.value,
                                encodedOutput: e.target.value.length == 0 ? '' : encodeURIComponent(e.target.value),
                            });
                        }}
                    >
                    </textarea>
                </FormGroup>
            </div>

            <div className="col">
                <FormGroup>
                    <label>{t('toolEncoderURL.outputLabel')}</label>
                    <textarea
                        className="form-control"
                        value={this.state.encodedOutput}
                        style={{
                            resize: 'vertical',
                            minHeight: '200px',
                        }}
                        readOnly={true}
                    >
                    </textarea>
                </FormGroup>
            </div>
        </div>
    </FormGroup>
</Application>
        );
    }
}
export default withTranslation('common')(RouteToolsEncoderURL);
